export default __webpack_public_path__ + "static/wonderingBaby-1eca60ec975606fcea86dc5a3acb378d.svg";